// @ts-nocheck
import React, { useState, useContext, useEffect } from 'react';
import Router from 'next/router';
import Breadcrumbs from '@/components/breadcrumbs';
import SettingsMenu from '@/components/settings/menu';
import Helper from '@/utils/helper';
import CreateTemplateComponent from '@/components/template/create-template';
import { createFileRoute } from '@tanstack/react-router'



function CreateTemplate(props: any) {

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const onSave = async (template: any) => {
    await Helper.waitABit();
    Helper.nextRouter(Router.push, `/settings/template/edit?name=${template.Name}&module=${template.Module}&templateType=${template.TemplateType}`);
  };

  const onCancel = () => {
    Helper.nextRouter(Router.push, `/settings/template/list`);
  };

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '', suppressLink: true },
              { text: 'Templates', link: '/settings/template/list' },
              { text: 'Create Template', link: '/settings/template/create' },
            ]}
          />
        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <CreateTemplateComponent onSave={onSave} onCancel={onCancel} />
        </div>
      </div>

      <style jsx>{`
        .row {
          display: flex;
        }
        .column {
          display: flex;
          flex-basis: 0;
          flex-direction: column;
          flex-grow: 1;
        }
        .column :global(.textarea-container) {
          height: 100%;
        }
        .column + .column {
          margin-left: 1.25rem;
        }
      `}</style>
    </div>
  );
}
export default CreateTemplate

export const Route = createFileRoute('/_authenticated/settings/template/create')({ component: CreateTemplate })
